<template>
  <v-card v-if="editObject" v-click-outside="unfocusEntireCard" :flat="flat" :color="flat ? 'transparent' : ''">
    <slotted-card :editable="true" :externalEditTrigger="edittrigger" @editMode="setEditMode" @valid="setValid">
      <template v-slot:header>
        <slot name="header" :editMode="editMode" :setEditMode="setEditMode">
          <v-row no-gutters class="mx-3 mt-1" justify="space-between" align="center">
            <v-col cols="auto">
              <SectionHeader :title="title ? title : 'No title provided'" />
            </v-col>
            <v-col v-if="!readonly" cols="auto">
              <v-btn v-if="deleteMethod != undefined" icon small class="mr-2"
                @click="() => { setEditMode(false); deleteMethod(); }">
                <v-icon v-text="'mdi-delete'" size="22"></v-icon>
              </v-btn>
              <v-btn icon small @click="setEditMode(!editMode)">
                <v-icon v-text="editMode ? 'mdi-close' : 'mdi-pencil'"></v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </slot>
      </template>
      <template v-slot:content>
        <slot name="content" :item="editObject" :copy="copyObject" :editMode="editMode" :edittrigger="edittrigger"
          :handleFocus="handleFocus">
          content
        </slot>
        <edit-bar v-if="editMode" :externalTrigger="editMode" :saveable="valid && IsChanged" @saveEmit="handleSave"
          @modeEmit="setEditMode(false)">
        </edit-bar>
      </template>
    </slotted-card>
  </v-card>
</template>

<script>
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "EntityEditCard",
  props: {
    title: String,
    item: Object,
    overrideCopyItem: Object, //only used when you want provide default values in item that differ from original. ex prove default service agreement instead of null.
    saveMethod: Function,
    deleteMethod: [Promise, Function],
    flat: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SlottedCard,
    EditBar,
    SectionHeader,
  },
  mixins: [],

  data() {
    return {
      editObject: null,
      copyObject: null,
      edittrigger: 1,
      editMode: false,
      valid: false,
    };
  },

  mounted() {
    this.SetDetails();
  },

  methods: {
    setEditMode(bool) {
      this.editMode = bool;
    },

    setValid(bool) {
      this.valid = bool;
    },

    SetDetails() {
      this.editObject = Object.assign({}, this.item);
      //normally just copy the item to check if it has changed, but can check for changes against another object if needed.
      var copytarget = this.overrideCopyItem !== undefined ? this.overrideCopyItem : this.item;
      this.copyObject = Object.assign({}, copytarget);
    },

    handleFocus(focusBool) {
      if (!this.editMode && focusBool) {
        this.setEditMode(true)
      }
    },

    async handleSave() {
      await this.saveMethod(this.editObject);
      this.setEditMode(false)
    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.setEditMode(false)
      }
    },
  },

  computed: {
    IsChanged() {
      //console.log("IsChanged", this.editObject, this.copyObject, !this.SameValue(this.editObject, this.copyObject));
      if (this.editObject && this.copyObject) {
        return !this.SameValue(this.editObject, this.copyObject);
      } else {
        return false;
      }
    },
  },

  watch: {
    item: function () {
      this.SetDetails();
    },

    editMode: function (val) {
      if (!val) {
        this.SetDetails();
      }
    },
  },
};
</script>


<style lang='scss'></style>